/* eslint-disable no-nested-ternary */
import type React from 'react';
import { useState } from 'react';
import { Box, TextField, IconButton, InputAdornment, useTheme } from '@mui/material';
import { Send } from '@mui/icons-material';

interface MessageInputProps {
  onSendMessage: (message: string) => void;
  disabled?: boolean;
}

export const MessageInput: React.FC<MessageInputProps> = ({ onSendMessage, disabled = false }) => {
  const [message, setMessage] = useState('');
  const theme = useTheme();

  const containerStyles = {
    padding: '16px',
    backgroundColor: '#ffffff',
    borderTop: '1px solid #e0e0e0',
  };

  const textFieldStyles = {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#f5f5f5',
      borderRadius: '24px',
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        border: 'none',
      },
      '&.Mui-focused fieldset': {
        border: `2px solid ${theme.palette.primary.light}`,
      },
    },
    '& .MuiInputBase-input': {
      color: '#333333',
      padding: '8px 16px', // Reducido de 12px a 8px
    },
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim() && !disabled) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <Box sx={containerStyles}>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Escribe tu mensaje..."
          disabled={disabled}
          sx={textFieldStyles}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  type="submit"
                  disabled={!message.trim() || disabled}
                  sx={{
                    backgroundColor:
                      message.trim() && !disabled ? theme.palette.primary.main : 'transparent',
                    color: message.trim() && !disabled ? 'white' : '#cccccc',
                    padding: '6px',
                    '&:hover': {
                      backgroundColor:
                        message.trim() && !disabled ? theme.palette.primary.dark : 'transparent',
                    },
                  }}>
                  <Send sx={{ fontSize: 18 }} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </form>
    </Box>
  );
};
